import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEWCOMMENT_LIST_ERROR':
      return action.error;

    case 'ONEWAYINTERVIEWCOMMENT_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEWCOMMENT_LIST_LOADING':
      return action.loading;

    case 'ONEWAYINTERVIEWCOMMENT_LIST_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEWCOMMENT_LIST_SUCCESS':
      return action.retrieved;

    case 'ONEWAYINTERVIEWCOMMENT_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function eventSource(state = null, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEWCOMMENT_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function filtersData(state = null, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEWCOMMENT_LIST_FILTER':
      return action.filtersData;

    case 'ONEWAYINTERVIEWCOMMENT_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function sortData(state = null, action) {
  switch (action.type) {
    case 'ONEWAYINTERVIEWCOMMENT_LIST_SORT':
      return action.sortData;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved, eventSource, filtersData, sortData });
